import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

import {
  Avatar,
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Rating,
  Typography,
  useTheme,
} from "@mui/material";
import { Close } from "@mui/icons-material";

import { RootState } from "../../../store/Index";
import { ICreateReviewDialogProps } from "../types/reviews";
import ResizableTextarea from "../../../components/common/ResizableTextArea";
import { tokens } from "../../../theme";
import { User } from "../../../store/slice/AuthSlice";

export const CreateReviewDialog: React.FC<ICreateReviewDialogProps> = ({
  createReviewOpen,
  formData,
  event,
  formLoading,
  handleCreateReview,
  handleCommentChange,
  pilot,
  resetForm,
  setCreateReviewOpen,
  setFormData
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const reduxTheme = useSelector((state: RootState) => state.theme);

  const user = useSelector((state: RootState) => state.auth.user) as User | null;

  useEffect(() => {
    if (user) {
    setFormData({
      ...formData,
      rater: user.id
    });
    }
  }, [user]);

  console.log({ event });

  useEffect(() => {
    if (event) {
    setFormData({
      ...formData,
      stream: event.id,
      stream_id: event.id
    });
    }
  }, [event]);

  if (!pilot || !event || !formData) return null;

  if (!user) toast.error('You have to be logged in to add reviews.');

  return (
    <Dialog
      open={createReviewOpen}
      onClose={() => {
        setCreateReviewOpen(false);
        resetForm();
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        {`Review for the stream: ${event?.title}`}
        <IconButton
          onClick={() => {
            setCreateReviewOpen(false);
            resetForm();
          }}
          sx={{ position: "absolute", right: 8, top: 8 }}
          disabled={formLoading}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          justifyContent={'center'}>
            <Avatar
              src={pilot?.avatar}
              sx={{ mb: 1, width: 100, height: 100, borderRadius: "50%" }}
            />
            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
              {pilot.name} {pilot.surname}
            </Typography>
            {pilot.department?.length !== 0 ? (
              <Chip
                label={pilot.department}
                size="small"
                variant="outlined"
                sx={{
                  borderRadius: 1.5,
                  borderColor: reduxTheme.primary_colors[800],
                }}
              />
            ) : null}
        </Box>
        <Box
          display={'flex'}
          flexDirection={'column'}
          mt={2}
          alignItems={'center'}
          justifyContent={'center'}>
          <Rating
            size={'large'}
            value={formData.rating}
            sx={{ mb: 1 }}
            defaultValue={0}
            onChange={(event, newValue) => {
              setFormData({
                ...formData,
                rating: newValue
              });
            }}
            precision={1}
          />
          <ResizableTextarea
            label="Comment"
            value={formData.comment || ""}
            onChange={handleCommentChange}
            colors={colors}
            reduxTheme={reduxTheme}
            placeholder="Share your feedback..."
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => {
            setCreateReviewOpen(false);
            resetForm();
          }}
          sx={{
            color: reduxTheme.primary_colors[400],
            bgcolor: 'transparent',
            border: '1px solid',
            borderColor: reduxTheme.primary_colors[400]
          }}
        >
          Discard
        </Button>
        <Button
          variant="contained"
          onClick={handleCreateReview}
          disabled={formLoading}
          sx={{ bgcolor: reduxTheme.primary_colors[400] }}
        >
          {formLoading && <CircularProgress size={20} sx={{ mr: 1 }} />}Add Pilot Review
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateReviewDialog;
